// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AuctionActivityWrapper_wrapper__1JNe0"};